import React from 'react';
import { Badge } from '../ui/badge';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Globe, RefreshCw, Search, ShoppingCart, Check } from 'lucide-react';
import { services } from '../../data/mock';

const iconMap = {
  Globe,
  RefreshCw,
  Search,
  ShoppingCart,
};

export const Services = () => {
  return (
    <section id="servicos" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <Badge className="mb-6 bg-teal-100 text-teal-700 border-teal-200 hover:bg-teal-100">
            Serviços
          </Badge>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            Soluções Completas Para o Seu Negócio Digital
          </h2>
          <p className="text-lg text-slate-600">
            Oferecemos um conjunto abrangente de serviços para garantir que a sua presença online seja um sucesso.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="group bg-white hover:shadow-2xl hover:shadow-slate-200/50 transition-all duration-500 border-slate-100 hover:border-teal-200 overflow-hidden"
              >
                <CardHeader className="pb-4">
                  <div className="w-14 h-14 rounded-xl bg-teal-100 group-hover:bg-teal-600 flex items-center justify-center mb-4 transition-colors duration-300">
                    <IconComponent className="w-7 h-7 text-teal-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  <CardTitle className="text-xl font-bold text-slate-900 group-hover:text-teal-700 transition-colors">
                    {service.title}
                  </CardTitle>
                  <CardDescription className="text-slate-600 text-base">
                    {service.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-3">
                    {service.features.map((feature, index) => (
                      <li key={index} className="flex items-center gap-3">
                        <div className="w-5 h-5 rounded-full bg-teal-100 flex items-center justify-center flex-shrink-0">
                          <Check className="w-3 h-3 text-teal-600" />
                        </div>
                        <span className="text-slate-600 text-sm">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
